import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '@/services/api'
import {
  Transaction,
  TransactionsFilter,
  TransactionsResponse,
  TransactionSummary,
  RefundRequest,
} from '@/types'
import { toast } from 'sonner'

const TRANSACTIONS_QUERY_KEY = 'transactions'

export const useTransactions = (filters: TransactionsFilter = {}) => {
  return useQuery<TransactionsResponse>({
    queryKey: [TRANSACTIONS_QUERY_KEY, filters],
    queryFn: async () => {
      const params = new URLSearchParams()
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          params.append(key, String(value))
        }
      })

      const { data } = await api.get(`/transactions?${params.toString()}`)
      return data
    },
  })
}

export const useTransaction = (id: string) => {
  return useQuery<Transaction>({
    queryKey: [TRANSACTIONS_QUERY_KEY, id],
    queryFn: async () => {
      const { data } = await api.get(`/transactions/${id}`)
      return data
    },
    enabled: !!id,
  })
}

export const useTransactionSummary = () => {
  return useQuery<TransactionSummary>({
    queryKey: [TRANSACTIONS_QUERY_KEY, 'summary'],
    queryFn: async () => {
      const { data } = await api.get('/transactions/summary')
      return data
    },
  })
}

export const useRefundTransaction = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, request }: { id: string; request: RefundRequest }) => {
      const { data } = await api.post(`/transactions/${id}/refund`, request)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [TRANSACTIONS_QUERY_KEY] })
      toast.success('Reembolso procesado')
    },
  })
}
